<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Add Holiday</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="holiday.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Date
                            </label>
                            <div class="md-layout-item">
                                <md-datepicker
                                        v-model="holiday.holiday_date"
                                        :md-model-type="String" md-immediately
                                        :class="{ 'md-invalid': !!apiValidationErrors.holiday_date }"
                                >
                                    <label>Select date ...</label>
                                    <validation-error :errors="apiValidationErrors.holiday_date" />
                                </md-datepicker>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Repeat
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-radio v-model="holiday.repeat" :value="1">Yes</md-radio>
                                    <md-radio v-model="holiday.repeat" :value="0">No</md-radio>
<!--                                    <md-input v-model="holiday.repeat" />-->
                                    <validation-error :errors="apiValidationErrors.repeat" />
                                </md-field>
                            </div>
                        </div>

                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Holiday</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({
        holiday: {
            type: 'holidays',
            name: null,
            holiday_date: null,
            repeat: null,
        },
    }),
    created () {
    },

    methods: {
        async add () {
            try {
                console.log(this.holiday);
                await this.$store.dispatch('holidays/add', this.holiday);
                this.notifySuccess('Holiday added successfully.');
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].detail);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },

        goBack () {
            this.$router.push({ name: 'Holidays List' });
        },
    },
};
</script>
